export default __webpack_public_path__ + "static/media/contact.203ab43e.png";